import React, { useEffect, useState } from "react";
import useCountryPathologies from "../../../../components/Candidato/useCountryPathologies";
import useServiceQuery from "../../../../queries/service/useServiceQuery";
import useWindowWidth from "../../../../util/useWindowWidth";
import ServicePage from "./ServicePage";

export type TServicePageTab = "notes" | "coordinator_notes";

interface IServicePageContainerProps {
  match: {
    params: {
      serviceId: string;
    };
  };
}

const ServicePageContainer = (props: IServicePageContainerProps) => {
  const { match } = props;
  const [tab, setTab] = useState<TServicePageTab>("coordinator_notes");
  const [valuationNotes, setValuationNotes] = useState({
    value: "",
    ready: false,
  });
  const serviceQuery = useServiceQuery(match.params.serviceId);
  const windowWidth = useWindowWidth();
  const pathologyOptions = useCountryPathologies(
    serviceQuery.data?.Business_Country ?? "es"
  );

  useEffect(() => {
    if (serviceQuery.isSuccess && serviceQuery.data && !valuationNotes.ready) {
      setValuationNotes({
        ready: true,
        value: serviceQuery.data.notesDuringValuation ?? "",
      });
    }
  }, [serviceQuery, valuationNotes.ready]);

  const handleTabChange = (
    event: React.ChangeEvent<{}>,
    newValue: TServicePageTab
  ) => {
    setTab(newValue);
  };

  if (!serviceQuery.data) {
    return null;
  }

  const handleValuationNotesChange = (notes: string) => {
    setValuationNotes((prevState) => ({
      ...prevState,
      value: notes,
    }));
  };

  if (pathologyOptions.length === 0) {
    return null;
  }

  return (
    <ServicePage
      service={serviceQuery.data}
      isLoading={serviceQuery.isLoading}
      tab={tab}
      onTabChange={handleTabChange}
      windowWidth={windowWidth}
      valuationNotes={valuationNotes.value}
      onValuationNotesChange={handleValuationNotesChange}
      pathologyOptions={pathologyOptions}
    />
  );
};

export default ServicePageContainer;
